import { PreStayResponseStatusEnum, PreStaySendStatusEnum, PreStayStatusEnum } from "model"
import React from "react"
import { PreStayStatus } from "./PreStayStatus"
import { PreStaySendStatus } from "./PreStaySendStatus"
import { PreStayResponseStatus } from "./PreStayResponseStatus"

export type PreStayStatusFilterProps = {
  statusSelected: PreStayStatusEnum[],
  sendStatus: PreStaySendStatusEnum[],
  responseStatus: PreStayResponseStatusEnum[],
  onChange: ({ statusSelected, sendStatus, responseStatus }: { statusSelected: PreStayStatusEnum[], sendStatus: PreStaySendStatusEnum[], responseStatus: PreStayResponseStatusEnum[] }) => void,
}

export const PreStayStatusFilter = ({ statusSelected, sendStatus, responseStatus, onChange }: PreStayStatusFilterProps) => {



  return <div className="row">
    <div className="col-4">

      <h2>Statut</h2>
      <ul className="list-group">
        {Object.values(PreStayStatusEnum).map((status) => {
          const isSelected = statusSelected.includes(status)
          return <li className="list-group-item d-flex align-items-center justify-content-center" key={status} >
            <input id={status} checked={isSelected} type='checkbox' onClick={(e) => {
              if (isSelected) {
                onChange({
                  sendStatus,
                  responseStatus,
                  statusSelected: statusSelected.filter((s) => s !== status)
                })
              } else {
                onChange({
                  sendStatus,
                  responseStatus,
                  statusSelected: [...statusSelected, status]
                })
              }
            }}>
            </input>
            <label style={{ margin: 0 }} className="ml-1" htmlFor={status}>
              <PreStayStatus status={status} />
            </label>

          </li>
        })}
      </ul>
    </div>
    <div className="col-4">

      <h2>Envoi</h2>
      <ul className="list-group">
        {Object.values(PreStaySendStatusEnum).map((sendStatusItem) => {
          const isSelected = sendStatus.includes(sendStatusItem)
          return <li className="list-group-item d-flex align-items-center justify-content-center" key={sendStatusItem} >
            <input id={sendStatusItem} checked={isSelected} type='checkbox' onClick={(e) => {
              if (isSelected) {
                onChange({
                  statusSelected,
                  responseStatus,
                  sendStatus: sendStatus.filter((s) => s !== sendStatusItem)
                })
              } else {
                onChange({
                  statusSelected,
                  responseStatus,
                  sendStatus: [...sendStatus, sendStatusItem]
                })
              }
            }}>
            </input>
            <label style={{ margin: 0 }} className="ml-1" htmlFor={sendStatusItem}>
              <PreStaySendStatus sendStatus={sendStatusItem} />
            </label>

          </li>
        })}
      </ul>
    </div>
    <div className="col-4">
      <h2>Response</h2>
      <ul className="list-group">
        {Object.values(PreStayResponseStatusEnum).map((responseStatusItem) => {
          const isSelected = responseStatus.includes(responseStatusItem)
          return <li className="list-group-item d-flex align-items-center justify-content-center" key={responseStatusItem} >
            <input id={responseStatusItem} checked={isSelected} type='checkbox' onClick={(e) => {
              if (isSelected) {
                onChange({
                  statusSelected,
                  sendStatus,
                  responseStatus: responseStatus.filter((s) => s !== responseStatusItem)
                })
              } else {
                onChange({
                  statusSelected,
                  sendStatus,
                  responseStatus: [...responseStatus, responseStatusItem],
                })
              }
            }}>
            </input>
            <label style={{ margin: 0 }} className="ml-1" htmlFor={responseStatusItem}>
              <PreStayResponseStatus responseStatus={responseStatusItem} />
            </label>

          </li>
        })}
      </ul>

    </div>
  </div>

}